import { render, staticRenderFns } from "./Blockdit.vue?vue&type=template&id=1fd3f4be&scoped=true&"
import script from "./Blockdit.vue?vue&type=script&lang=js&"
export * from "./Blockdit.vue?vue&type=script&lang=js&"
import style0 from "./Blockdit.vue?vue&type=style&index=0&id=1fd3f4be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3f4be",
  null
  
)

export default component.exports